<template>
	<div class="wrap">
		<h1>{{ examination_name }}诚信承诺书</h1>
		<p class="line"></p>
		<div class="main" v-html="promise"></div>
		<div class="input">
			<p class="tip">注意:签名所填姓名须与真实姓名一致。委托他人报名的，视作本人已知晓并接受此《诚信承诺书》各条款。</p>
			<div class="username">
				<span>接受上述内容签名</span>
				<el-form :inline="true" :model="form" ref="formRef">
					<el-form-item
						style="margin-bottom: 0px;"
						prop="username"
						:rules="[{ validator: validateName, trigger: 'blur' }, { required: true, message: '真实姓名不能为空', trigger: 'blur' }]"
					>
						<el-input size="small" maxlength="30" v-model="form.username" placeholder="请填写真实姓名"></el-input>
					</el-form-item>
				</el-form>
				<span class="tip">(注意:签名所填姓名须与真实姓名一致。)</span>
			</div>
		</div>
		<div class="checkbox">
			<el-checkbox v-model="checked">我已阅读并同意遵守</el-checkbox>
			<span @click="handleTreaty()" class="href" title="点击查看">《报名系统用户协议》</span>
		</div>
		<div class="footer-btns">
			<el-button v-if="!checked || upl" type="info" :disabled="!checked || upl">我已阅读并完全理解</el-button>
			<el-button v-else type="primary" :disabled="!form.username" @click="onSubmit()">我已阅读并完全理解</el-button>
		</div>
		<p class="date">{{ nowDate }}</p>
		<!-- 报名系统用户协议 -->
		<treaty ref="treaty"></treaty>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Treaty from './Treaty';
import { MessageBox } from 'element-ui';
import { reqGetInstructionTxt, reqUploadFile } from '@/api';
import { validateName } from '@/tools/validate';
import html2canvas from 'html2canvas';
export default {
	components: {
		Treaty
	},
	data() {
		return {
			validateName,
			form: {
				username: ''
			},
			checked: false,
			upl: true,
			promise: '',
			nowDate: ''
		};
	},
	computed: {
		...mapState({
			examination_name: state => state.system.examInfo.examination_name,
			examination_id: state => state.system.examInfo.examination_id
		})
	},
	mounted() {
		this.currentTime();
		this.getPromise();
		let timer = setInterval(() => {
			this.time--;
			if (this.time <= 0) {
				this.time = 0;
				clearInterval(timer);
			}
		}, 1000);
	},
	methods: {
		currentTime() {
			setInterval(this.formatDate, 500);
		},
		formatDate() {
			let date = new Date();
			let year = date.getFullYear(); // 年
			let month = date.getMonth() + 1; // 月
			month = month < 10 ? '0' + month : month;
			let day = date.getDate(); // 日
			day = day < 10 ? '0' + day : day;
			let week = date.getDay(); // 星期
			let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
			let hour = date.getHours(); // 时
			hour = hour < 10 ? '0' + hour : hour; // 如果只有一位，则前面补零
			let minute = date.getMinutes(); // 分
			minute = minute < 10 ? '0' + minute : minute; // 如果只有一位，则前面补零
			let second = date.getSeconds(); // 秒
			second = second < 10 ? '0' + second : second; // 如果只有一位，则前面补零
			this.nowDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
		},

		// 获取承诺书
		getPromise() {
			reqGetInstructionTxt({
				id: this.examination_id
			}).then(res => {
				this.promise = res.data.promise;
				this.upl = false;
			});
		},
		// 提交
		onSubmit() {
			this.$refs['formRef'].validate(valid => {
				if (valid) {
					MessageBox.confirm('<strong style="color: #409EFF; font-size: 28px">' + this.form.username + '</strong>', '请确认姓名是否填写正确', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true
					}).then(() => {
						this.$loading();
						let oScrollHeight = document.querySelector('.menus-wrap').scrollHeight;
						html2canvas(document.querySelector('.wrap'), {
							scale: 2,
							height: oScrollHeight
						}).then(canvas => {
							let query = {};
							try {
								query = {
									file: this.dataURLtoFile(canvas.toDataURL('image/jpeg', 0.5), 'pic.jpeg')
								};
							} catch (e) {
								//TODO handle the exception
								query = {
									base64: canvas.toDataURL('image/jpeg', 0.5)
								};
							}
							reqUploadFile(query).then(res => {
								sessionStorage.setItem('name', this.form.username);
								this.$bus.$emit('update:name', this.form.username, res.data);
								this.$emit('update:active', 2);
							});
						});
					}).catch(() => {
						this.$message({
						type: 'info',
						message: '请重新填写姓名'
						});          
					});
				} else {
					return false;
				}
			});
		},
		// base64图片转file文件
		dataURLtoFile(dataurl, filename) {
			//将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
			var arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new File([u8arr], filename, {
				type: mime
			});
		},
		// 查看协议
		handleTreaty() {
			this.$refs.treaty.dialogVisible = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.wrap {
	padding-top: 10px;

	.date {
		font-size: 14px;
		color: #666;
		text-align: right;
		margin-right: 20px;
	}

	.href {
		font-size: 12px;
		font-weight: 500;
		color: #2461ed;
		cursor: pointer;
	}

	> h1 {
		font-size: 20px;
		font-weight: 500;
		color: #000;
		text-align: center;
	}

	> .line {
		border: 1px solid #e5e5e5;
		margin: 0 50px 20px;
	}

	.main {
		margin: 0 50px;
		padding: 20px 0;
		word-break: break-word;
		// height: calc(100vh - 543px);
		// overflow-x: hidden;
		// overflow-y: auto;

		h2 {
			text-align: center;
			font-size: 16px;
			font-weight: 500;
			color: #000;
		}

		> p {
			display: flex;
			flex-direction: column;

			> span {
				font-size: 14px;
				line-height: 1.7;
				margin-top: 15px;
			}
		}
	}

	.input {
		margin: 50px 50px 0;
		background: #f9f9f9;
		padding: 10px 20px;

		.username {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px;
			font-weight: 500;
			color: #0a0a0a;
			margin-top: 15px;

			.el-input {
				width: 200px;
				margin: 0 10px;
			}
		}

		.tip {
			font-size: 12px;
			font-weight: 500;
			color: #ff0707;
			text-align: center;
		}
	}

	.checkbox {
		margin: 20px 50px;
		text-align: center;
	}

	::v-deep.el-form-item__error {
		margin-left: 12px;
	}
}
</style>
